module.exports = __webpack_public_path__ + "img/theme_light.1404b1.svg";